/* eslint-disable no-underscore-dangle, no-useless-constructor */
import Choices from 'choices.js';

const EVENTS = {
  showDropdown: 'showDropdown',
  hideDropdown: 'hideDropdown',
  change: 'change',
  choice: 'choice',
  search: 'search',
  addItem: 'addItem',
  removeItem: 'removeItem',
  highlightItem: 'highlightItem',
  highlightChoice: 'highlightChoice',
  unhighlightItem: 'unhighlightItem',
};

export default class CustomChoices extends Choices {
  constructor(element, userConfig) {
    // Call the constructor of the parent class
    super(element, userConfig);
  }

  // Override the _handleChoiceAction method with custom implementation
  _handleChoiceAction(activeItems, element) {
    if (!activeItems || !element) {
      return;
    }

    // If we are clicking on an option
    const { id } = element.dataset;
    const choice = id && this._store.getChoiceById(id);

    if (!choice) {
      return;
    }

    const passedKeyCode =
      activeItems[0] && activeItems[0].keyCode ?
        activeItems[0].keyCode :
        undefined;
    const hasActiveDropdown = this.dropdown.isActive;

    // Update choice keyCode
    choice.keyCode = passedKeyCode;

    this.passedElement.triggerEvent(EVENTS.choice, {
      choice,
    });

    if (!choice.disabled) {
      const canAddItem = this._canAddItem(activeItems, choice.value);

      if (!choice.selected) {
        if (canAddItem) {
          this._addItem({
            value: choice.value,
            label: choice.label,
            choiceId: choice.id,
            groupId: choice.groupId,
            customProperties: choice.customProperties,
            placeholder: choice.placeholder,
            keyCode: choice.keyCode,
          });

          this._triggerChange(choice.value);
        }
      } else {
        this.removeActiveItemsByValue(choice.value);
        this._triggerChange(choice.value);
      }
    }

    this.clearInput();

    // We want to close the dropdown if we are dealing with a single select box
    if (hasActiveDropdown && this._isSelectOneElement) {
      this.hideDropdown(true);
      this.containerOuter.focus();
    }
  }

  getCurrentState() {
    return this._currentState;
  }
}
